import React from "react";
import Layout from "../layouts/index";
import DeliveryInfo from "../screens/Info/DeliveryInfo";

const DeliveryInfoPage = () => {
  return (
    <Layout>
      <DeliveryInfo />
    </Layout>
  );
};

export default DeliveryInfoPage;
